import { USER_ROLES } from 'swag-common/constants/user-roles';
import { isSuperAdmin } from './is-superadmin.util';
import { isOpsTeamUser } from './is-user-ops-team.util';
import { isCsAssociateUser } from './is-cs-associate.util';
export const isHighPrivilegesRole = userRole => userRole === USER_ROLES.ADMIN || isOpsTeamUser(userRole) || isCsAssociateUser(userRole) || isSuperAdmin(userRole);